// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"01332943","563":"af31fb7d"}[chunkId] + ".chunk.css";
};